export enum SourceType {
  AA = 1,
  Institution = 2,
  Person = 3,
  DigitalMeasures = 4,
}
